import React from "react";
import Tooltip from "@mui/material/Tooltip";
import { toast } from "react-toastify";
import * as IconsSVG from "../../../../../../assets/iconsSVG";
import * as Styles from "../../styles";
import { Lead } from "../../../../../../interfaces";

interface Props {
  item: Lead;
  isShared?: boolean;
  onEtiquetaClick: (event: React.MouseEvent, idLeadCorretor: string) => void;
}

export const EtiquetaCell: React.FC<Props> = ({
  item,
  isShared,
  onEtiquetaClick,
}) => (
  <Styles.Td style={{ width: 80, cursor: "auto" }}>
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        paddingRight: 8,
        boxSizing: "border-box",
        alignItems: "center",
      }}
    >
      <Tooltip
        followCursor
        title={
          isShared
            ? "Exclusivo para o dono do lead"
            : item?.etiqueta?.nome ?? "Sem informação da etiqueta"
        }
        placement="top-start"
        arrow
      >
        <div>
          <p
            style={{
              padding: "2px 6px",
              backgroundColor: item?.etiqueta?.cor ?? "transparent",
              color: item?.etiqueta ? "white" : "#424248",
              width: "fit-content",
              maxWidth: "65px",
              overflow: "hidden",
              textOverflow: "ellipsis",
              fontSize: 12,
              borderRadius: 8,
            }}
          >
            {item?.etiqueta?.nome ?? "--"}
          </p>
        </div>
      </Tooltip>
      <Styles.OnClick
        onClick={(event) => {
          if (isShared) {
            toast.warning("Exclusivo para o dono do lead");
            return;
          }
          onEtiquetaClick(event as any, item.idLeadCorretor);
        }}
      >
        <IconsSVG.ArrowDownIcon className="arrowIcon" />
      </Styles.OnClick>
    </div>
  </Styles.Td>
);
